<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UpPUID/tc-custom/9781638298168.jpg?1705687883162" alt="This image is the cover for the book The Giant of the Beyond"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Giant of the Beyond
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial Nova",sans-serif;color:black;'>Professor Stan Christen struggles to come to terms with a dark moment in his past. Driven to write to ease the pain, <em>The Giant of the Beyond</em> is his therapy. The Giant sees Stan as a 10-year-old boy. With his friend, Walter Davidson, they both conjure up a plan to take an ill-advised bike trip in Rougemont Forest. Driven by a sense of adventure and a cavalier attitude, they each defy the stern warnings of their parents and Mrs. F., their teacher. To some, the forest was hell. To Stan and Walter, it represented freedom. To one man, it was the chance to mop up unfinished, twisted family business.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shane Offerman
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:18.0pt;margin-bottom:.0001pt;margin-left:54.0pt;text-align:justify;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;'><span style="font-size:15px;color:black;">Shane Offerman lives in Ottawa, Ontario with his wife Donna. He has three adult kids, Emily, Jacob, and Meghan. When Shane takes a break from writing, he&rsquo;s outdoors cooking on the grill, nurturing his small, English garden, or building wood furniture. Shane is also a certified black belt in Tae Kwon Do.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8b9f3b3e